import { Component, Input, OnInit } from '@angular/core';
import {FlatTreeControl} from '@angular/cdk/tree';
import {MatTreeFlatDataSource, MatTreeFlattener} from '@angular/material/tree';
import { FoodNode, ExampleFlatNode } from 'projects/shared/src/lib/models/ProjectTree';
import { TenantService } from 'projects/shared/src/lib/services/tenant.service';
import { UserDto } from 'projects/shared/src/lib/models/User';
import { AuditFilter } from 'projects/shared/src/lib/models/AuditFilter';
import { NotificationService } from 'projects/shared/src/lib/services/notification.service';

const TREE_DATA: FoodNode[] = [
  {
    name: 'Fruit',
    children: [{name: 'Apple'}, {name: 'Banana'}, {name: 'Fruit loops'}],
  },
  {
    name: 'Vegetables',
    children: [
      {
        name: 'Green',
        children: [{name: 'Broccoli'}, {name: 'Brussels sprouts'}],
      },
      {
        name: 'Orange',
        children: [{name: 'Pumpkins'}, {name: 'Carrots'}],
      },
    ],
  },
];

const PROJECTS: FoodNode[] = [
  {
    name: 'Projekt1',
    children: [{name: 'PGR11'}, {name: 'PGR12'}, {name: 'PGR13'}],
  },
  {
    name: 'Projekt2',
    children: [
      {
        name: 'PGR21',
      },
      {
        name: 'PGR22',
      },
    ],
  },
];


@Component({
  selector: 'show-user-projects',
  templateUrl: './show-user-projects.component.html',
  styleUrls: ['./show-user-projects.component.css']
})
export class ShowUserProjectsComponent implements OnInit {

  @Input('user') user!:UserDto;

  private _transformer = (node: FoodNode, level: number) => {
    return {
      expandable: !!node.children && node.children.length > 0,
      name: node.name,
      level: level,
    };
  };

  treeControl = new FlatTreeControl<ExampleFlatNode>(
    node => node.level,
    node => node.expandable,
  );

  treeFlattener = new MatTreeFlattener(
    this._transformer,
    node => node.level,
    node => node.expandable,
    node => node.children,
  );

  dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);

  hasChild = (_: number, node: ExampleFlatNode) => node.expandable;

      emptyGuid = '00000000-0000-0000-0000-000000000000';
      auditFilter: AuditFilter = {
        type: "PGR",
        action: "",
        //action: "UpdTGR",
        userId: this.emptyGuid,
        //userId: "70f4174f-17c5-454f-aa52-0b70ea3a00d7",
        projectId: this.emptyGuid,
        //projectId: "2828a047-6761-4e5e-b990-84224f1cc591",
        groupRoleId: this.emptyGuid,
        //groupRoleId: "bc77f89c-3a81-4dba-8051-3c415cb81edf",
        createdBy: this.emptyGuid, //creator_Id
        //createdBy: "fdfc41f0-6ede-4fcc-a727-3eb938ee4749", //creator_Id
        startTime: "",
        //startTime: "12.05.2025, 16:42:28.050",
        endTime: ""
        //endTime: "20.05.2025, 15:03:20.432"
      };
    
  

  constructor(
    private tenantService:TenantService,
    private notificationService: NotificationService
    

  ) 
  {
    //this.dataSource.data = TREE_DATA;
    //this.dataSource.data = PROJECTS;

  }

  ngOnInit() {
    this.tenantService.getUserProjectsAndGrouproles(this.tenantService.currentTenantName, this.user.id).subscribe({
      next: (foodNode: FoodNode[]) => {
        this.dataSource.data = foodNode;
      },
      error: (error: any) => {
        //this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["GROUPROLEUSERSRETRIEVEDERROR"]}`)
      }
    });

  }

      exportAuditData() {
      //this.auditFilter.projectId = this.proj.id;
      this.auditFilter.userId = this.user.id;
      this.tenantService.exportAuditLog(this.tenantService.currentTenantName, this.auditFilter).subscribe({
        next: (response) => {
          //this.isLoadingResults = false;
          //this.isRateLimitReached = true;
        this.notificationService.success("", "Excel Datei wird erstellt und steht in Kürze unter Dateidownload bereit!");
          // console.log("------> response: ", response)
        },
        error: (error: any) => {
          // this.isLoadingResults = false;
          //this.isRateLimitReached = true;
          this.notificationService.error("Fehler", "Fehler Audit Log Export")
          console.log("------> error: ", error)
          this.notificationService.info("", error)
        }
      });
    }


}
